import * as React from 'react';
import { TextFieldCore } from '@core-front/textfield';
import ClearButton from '@telia-front/clear-button';
import FormHelper from '@telia-front/form-helper';
import Icon from '@telia-front/icon';
import Image from '@telia-front/image';
class TextField extends React.Component {
    constructor() {
        super(...arguments);
        this.input = null;
        this.setInputRef = (element) => {
            this.input = element;
            if (element && this.props.inputRef) {
                this.props.inputRef(element);
            }
        };
    }
    render() {
        return (React.createElement(TextFieldCore, Object.assign({}, this.props, { inputRef: this.setInputRef, components: {
                ClearButton,
                FormHelper,
                Icon,
                Image,
            } })));
    }
}
TextField.defaultProps = {
    id: 'id-0',
    type: 'text',
};
export default TextField;
